import { type CrmMode } from "@sp-crm/core";

export {
    helpCenterForCrmMode,
    recordTypesForCrmMode,
    resolveCrmMode,
} from "@sp-crm/core";
export type { CrmMode, CrmModeInfo } from "@sp-crm/core";

export const placementClientsSettingsLabel = (mode: CrmMode): string =>
    mode === "combined" ? "Clients - Placement" : "Clients";

export const homeCareClientsSettingsLabel = (mode: CrmMode): string =>
    mode === "combined" ? "Clients - Home Care" : "Clients";

export const placementClientsFileShareLabel = (mode: CrmMode): string =>
    mode === "combined"
        ? "Can be shared with placement clients"
        : "Can be shared with clients";

export const homeCareClientsFileShareLabel = (mode: CrmMode): string =>
    mode === "combined"
        ? "Can be shared with home care clients"
        : "Can be shared with clients";
